const List = () => import(/* webpackChunkName: "guia-analise-bundle" */ './main.vue');

export default [
  {
    name: 'relatorio/guias-em-analise',
    path: '/relatorio/guias-em-analise',
    components: { default: List },
    meta: {
      requiresAuth: true,
      breadcrum: 'Guias em Análise',
      icon: 'file-excel',
      can: 'rep085',
      on: 'report',
      bisneto: true,
    },
  },
];
